import React from "react";
const AccessibilityIcon = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "15",
    height: "19",
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: className ? `${className}-path` : "",
    fill: "#000000",
    d: "M8.18 4.133a2.076 2.076 0 0 0 2.084-2.066A2.076 2.076 0 0 0 8.18 0a2.076 2.076 0 0 0-2.085 2.067c0 1.141.934 2.066 2.085 2.066ZM17 6.505c0-.25-.1-.489-.278-.665a.954.954 0 0 0-.671-.276H.949c-.251 0-.493.1-.67.276a.937.937 0 0 0 .523 1.595l4.811.461a.512.512 0 0 1 .46.521l-.139 4.054c0 .1-.008.201-.024.3L4.787 19.95a.91.91 0 0 0 .166.671.925.925 0 0 0 .591.366.942.942 0 0 0 .68-.134.927.927 0 0 0 .401-.561l1.328-5.666a.408.408 0 0 1 .401-.318.415.415 0 0 1 .401.318l1.33 5.668c.056.23.2.432.401.561.201.13.445.177.681.133a.923.923 0 0 0 .591-.365.908.908 0 0 0 .165-.671l-1.154-7.365c-.016-.1-.024-.2-.024-.3l-.143-3.86a.505.505 0 0 1 .464-.524l5.132-.476a.952.952 0 0 0 .571-.315.936.936 0 0 0 .231-.606Z"
  }));
};
export default AccessibilityIcon;